import axios from "axios";

const idServerApi = axios.create({
  baseURL:
    process.env.REACT_APP_ID_SERVER_URL ||
    "https://identity-api.dev.hissa.com/v1/",
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

export default idServerApi;
